<template>
  <section class="register-form pb-144 pt-89">
    <div class="register-form__inner flex column" v-if="!register_finished">
      <h2 class="f-34 pangram-extrabold">{{ $fn.tr("რეგისტრაცია") }}</h2>
      <p class="f-16 bold mb-34 mt-21">{{ $fn.tr("Registration Text") }}</p>
      <el-form
        class="
          register-form__fields
          flex
          column
          bg-white
          pt-55
          pb-55
          pl-55
          pr-55
        "
      >
        <el-alert v-if="formServerValidationError" class="mb-5" type="error">{{
          formServerValidationError
        }}</el-alert>

        <el-input
          :placeholder="$fn.tr('სახელი')"
          v-model="fd.firstName"
          class="mb-30"
        ></el-input>
        <el-input
          :placeholder="$fn.tr('გვარი')"
          v-model="fd.lastName"
          class="mb-30"
        ></el-input>
        <input
          v-model="fd.personCode"
          type="text"
          :placeholder="$fn.tr('პირადი ნომერი')"
          ref="id_field"
          class="mb-13"
        />
        <el-checkbox v-model="fd.foreign_citizen" class="mb-30">
          <span class="f-13 bold"> {{ $fn.tr("უცხოეთის მოქალაქე") }} </span>
        </el-checkbox>
        <div class="register-form__sex-boxes flex column mb-30">
          <span class="f-14 uppercase bold mb-16">{{
            $fn.tr("აირჩიე სქესი")
          }}</span>
          <div class="flex">
            <el-radio v-model="fd.sex" label="2">{{
              $fn.tr("მდედრობითი")
            }}</el-radio>
            <el-radio v-model="fd.sex" label="1">{{
              $fn.tr("მამრობითი")
            }}</el-radio>
          </div>
        </div>
        <div class="register-form__date-picker">
          <div class="register-form__date-picker--icons flex">
            <transition name="toggleContent">
              <svg
                id="fi-sr-calendar"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                v-if="!fd.birthDate"
                class="register-form__date-picker--calendar"
                :style="{ pointerEvents: 'none' }"
              >
                <path
                  id="Path_8776"
                  data-name="Path 8776"
                  d="M0,19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V10H0Zm17-4.5A1.5,1.5,0,1,1,15.5,16,1.5,1.5,0,0,1,17,14.5Zm-5,0A1.5,1.5,0,1,1,10.5,16,1.5,1.5,0,0,1,12,14.5Zm-5,0A1.5,1.5,0,1,1,5.5,16,1.5,1.5,0,0,1,7,14.5Z"
                  fill="#4d4d4f"
                />
                <path
                  id="Path_8777"
                  data-name="Path 8777"
                  d="M19,2H18V1a1,1,0,0,0-2,0V2H8V1A1,1,0,0,0,6,1V2H5A5.006,5.006,0,0,0,0,7V8H24V7A5.006,5.006,0,0,0,19,2Z"
                  fill="#4d4d4f"
                />
              </svg>
            </transition>

            <transition name="toggleContent">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.603"
                height="15.603"
                viewBox="0 0 15.603 15.603"
                class="register-form__date-picker--clear"
                v-if="fd.birthDate"
                @click="fd.birthDate = ''"
              >
                <path
                  id="Icon_metro-cancel"
                  data-name="Icon metro-cancel"
                  d="M22.96,9.64l-4.876,4.876L13.208,9.64l-2.926,2.926,4.876,4.876-4.876,4.876,2.926,2.926,4.876-4.876,4.876,4.876,2.926-2.926L21.01,17.442l4.876-4.876Z"
                  transform="translate(-10.283 -9.64)"
                  fill="#1a1a1a"
                />
              </svg>
            </transition>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7.857"
              viewBox="0 0 10 7.857"
              :style="{ pointerEvents: 'none' }"
            >
              <path
                id="Icon_material-play-arrow"
                data-name="Icon material-play-arrow"
                d="M12,7.5v10l7.857-5Z"
                transform="translate(17.5 -12) rotate(90)"
                fill="#4d4d4f"
              />
            </svg>
          </div>
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="fd.birthDate"
            type="date"
            :placeholder="$fn.tr('დაბადების თარიღი')"
            class="mb-30"
            clear-icon="register-form__date-picker--clear"
          >
          </el-date-picker>
        </div>

        <el-select
          v-model="fd.cityId"
          :placeholder="$fn.tr('საცხოვრებელი რაიონი')"
          class="mb-30"
        >
          <el-option
            v-for="c in cities"
            :key="c.id"
            :label="c.title"
            :value="c.id"
          >
          </el-option>
        </el-select>

        <el-input
          :placeholder="$fn.tr('მისამართი')"
          v-model="fd.address"
          class="mb-30"
        ></el-input>
        <el-input
          :placeholder="$fn.tr('ავტომობილის ნომერი')"
          v-model="fd.carNumber"
          class="mb-30"
        ></el-input>

        <el-input
          :placeholder="$fn.tr('ელ-ფოსტა')"
          v-model="fd.email"
          class="mb-13"
        ></el-input>
        <div class="register-form__verification-wrapper flex column mb-30">
          <div class="flex mb-30">
            <el-switch
              v-model="mail_switch"
              active-color="#28AD25"
              inactive-color="#C9C9CA"
              active-value="email"
              inactive-value="phone"
              :disabled="!fd.email.length"
            >
            </el-switch>

            <div class="flex column ml-10">
              <span class="f-13 bold">{{
                $fn.tr("ელ-ფოსტის ვერიფიკაცია")
              }}</span>
              <span class="f-13 bold">{{
                $fn.tr(
                  "ელ. ფოსტის მითითებისა და ვერიფიკაციის შემთხვევაში საჩუქრად დაგერიცხებათ 100 სითი ქულა"
                )
              }}</span>
            </div>
          </div>
          <div
            class="register-form__sms-code-wrapper mb-30 mt-10"
            v-if="email_code_sent && mail_switch === 'email'"
          >
            <el-input
              :placeholder="$fn.tr('E-mail კოდი')"
              v-model="fd.mailOtpCode"
            ></el-input>
            <span
              class="f-13 bold underline pointer"
              @click="send_email_code()"
              >{{ $fn.tr("თავიდან გაგზავნა ") }}</span
            >
          </div>

          <div class="flex mb-13">
            <div class="register-form__phone-wrapper flex" ref="phone_wrapper">
              <el-select
                v-model="fd.selected_prefix"
                @focus="set_phone_focus('focus')"
                @blur="set_phone_focus('blur')"
              >
                <el-option
                  v-for="prefix in prefixes"
                  :key="prefix.id"
                  :label="prefix.prefix"
                  :value="prefix.prefix"
                >
                </el-option>
              </el-select>
              <input
                v-model="fd.phone"
                type="text"
                @focus="set_phone_focus('focus')"
                @blur="set_phone_focus('blur')"
                ref="phone_field"
                :placeholder="phone_field_placeholder"
              />
            </div>

            <div
              class="
                register-form__button
                f-white
                pangram-extrabold
                f-12
                pl-30
                pr-30
                ml-30
              "
              :class="{ disabled: !fd.phone.length }"
              @click="send_phone_code()"
            >
              {{ $fn.tr("კოდის გაგზავნა") }}
            </div>
          </div>
          <span class="f-13 bold">{{
            $fn.tr("ტელეფონის ნომრის ვერიფიკაციისთვის გამოგეგზავნებათ SMS კოდი")
          }}</span>
        </div>

        <div
          class="register-form__sms-code-wrapper mb-30"
          v-if="phone_code_sent"
        >
          <el-input
            :placeholder="$fn.tr('sms კოდი')"
            v-model="fd.otp"
          ></el-input>
          <span
            class="f-13 bold underline pointer"
            @click="send_phone_code()"
            >{{ $fn.tr("თავიდან გაგზავნა ") }}</span
          >
        </div>

        <div class="register-form__check-terms flex al-center">
          <el-checkbox v-model="fd.terms_accepted"
            >
            {{ _.get($store, 'state.main.indx.widgets.loyal_registration_terms.text') }}
      

          </el-checkbox>

                <a
              :href="_.get($store, 'state.main.indx.widgets.loyal_registration_terms.link.url')"
              target="_blank"
              class="ml-10 bold f-14 underline"
              >{{ _.get($store, 'state.main.indx.widgets.loyal_registration_terms.link.title') }}</a
            >
        </div>
        <button
          class="
            register-form__button
            f-white
            pangram-extrabold
            pl-60
            pr-60
            mt-55
          "
          :class="
            !phone_code_sent || !fd.terms_accepted || !fd.email || !fd.firstName
              ? 'disabled'
              : ''
          "
          @click.prevent="check_submit()"
        >
          {{ $fn.tr("დადასტურება") }}
        </button>
      </el-form>
    </div>

    <RegisterResult
      v-if="register_finished"
      :register_finished="register_finished"
    />
  </section>
</template>

<script>
import RegisterResult from "@/components/modules/RegisterResult";
import fn from "../../helpers/func";
export default {
  components: {
    RegisterResult,
  },
  data() {
    return {
      fd: {
        personCode: "",
        firstName: "",
        lastName: "",
        birthDate: "",
        sex: "1",
        cityId: "",
        phone: "",
        email: "",
        address: "",
        otp: "",
        mailOtpCode: "",
        mailOtp: "phone",
        selected_prefix: "",
        foreign_citizen: false,
        terms_accepted: false,
      },
      formServerValidationError: "",
      phone_field_placeholder: "",
      //
      register_finished: "",

      // booleans
      mail_switch: false,
      email_verification: false,
      fields_valid: false,
      phone_code_sent: false,
      email_code_sent: false,
    };
  },

  mounted() {
    this.$on("go-back", () => {
      console.log("fired");
      this.register_finished = "";
    });
  },
  watch: {
    // foreign_citizen(ns, os) {
    //   console.log("new", ns);
    //   console.log("old", os);
    //   this.fd.personCode = "";
    //   this.$refs.id_field.value = "";
    // },
    // selected_prefix(ns) {
    //   this.phone_field = "";
    //   this.$refs.phone_field.value = "";
    //   let def = this.prefixes.find(item => item.prefix === ns);
    //   this.phone_field_placeholder = def.digits;
    //   console.log(this.phone_field);
    // },
    mail_switch(ns) {
      console.log(ns);
      if (ns === "email") {
        this.send_email_code(ns);
      }
    },
    prefixes: {
      deep: true,
      immediate: true,
      handler(ns) {
        console.log(ns);
        let def = ns.find((item) => item.slug === "default");
        this.fd.selected_prefix = def.prefix;
        this.phone_field_placeholder = def.digits;
        console.log(def);
      },
    },
  },
  computed: {
    cities() {
      return this.$store.state.main.indx.terms.cities;
    },
    prefixes() {
      return this.$store.state.main.indx.terms.number_prefixes;
    },
    foreign_citizen() {
      // return this.fd.foreign_citizen;
    },
  },
  methods: {
    send_email_code(ns) {
      this.fd.mailOtp = ns;
      this.send_code();
    },
    send_phone_code() {
      this.fd.mailOtp = "phone";
      this.send_code();
    },
    set_phone_focus(event_type) {
      if (event_type === "focus") {
        this.$refs.phone_wrapper.classList.add("custom_focus");
      } else {
        this.$refs.phone_wrapper.classList.remove("custom_focus");
      }
    },
    check_submit() {
      console.log(this.fd);
      this.submit_form();
      return false;
      if (
        this.fd.personCode.length === 0 ||
        this.fd.firstName.length === 0 ||
        this.fd.lastName.length === 0 ||
        this.fd.birthDate.length === 0 ||
        this.fd.cityId.length === 0 ||
        this.fd.phone.length === 0 ||
        this.fd.address.length === 0 ||
        this.fd.otp.length === 0 ||
        this.fd.mailOtp.length === 0 ||
        !this.fd.terms_accepted
      ) {
        this.fields_valid = false;
      } else {
        this.fields_valid = true;
      }

      if (this.fields_valid) {
        this.submit_form();
      } else {
        console.log("error");
      }
    },

    async submit_form() {
      console.log("kkjkjkjkj");
      this.formServerValidationError = "";
      const res = await fn.postData(
        "main/serviceCaller?callerId=CityMall_RegisterVirtualCard",
        {
          ...this.fd,
          phone: this.fd.selected_prefix + this.fd.phone,
        }
      );

      // return false;
      console.log(res);
      if (res.status !== 200) {
        this.formServerValidationError = _.get(res, "data.message");
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        this.register_finished = false;
      } else {
        this.register_finished = "success";
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }

      // console.log(res);
    },
    async send_code() {
      this.formServerValidationError = "";
      this.fd.mailOtp === "phone"
        ? (this.phone_code_sent = false)
        : (this.email_code_sent = false);

      const res = await fn.postData(
        "main/serviceCaller?callerId=CityMall_VerifyCode",
        {
          ...this.fd,
          phone: this.fd.selected_prefix + this.fd.phone,
        }
      );
      // console.log( res );
      if (res.status !== 200) {
        this.formServerValidationError = _.get(res, "data.message");
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      } else {
        this.fd.mailOtp === "phone"
          ? (this.phone_code_sent = true)
          : (this.email_code_sent = true);

        this.phone_code_sent = true;
      }
    },
    check_digits(e) {
      console.log(e.target.value);
      let val = e.target.value;
      if (!this.fd.foreign_citizen) {
        if (val && !isNaN(val) && val.toString().length <= 11) {
          this.fd.personCode = val;
        } else if (val.toString().length === 0) {
          this.fd.personCode = "";
        } else {
          e.target.value = this.fd.personCode;
        }
      }
      // console.log(this.id_field)
    },
    check_digits_phone(e) {
      let val = e.target.value;

      if (val && !isNaN(val)) {
        this.fd.phone = val;
      } else if (val.toString().length === 0) {
        this.fd.phone = "";
      } else {
        e.target.value = this.fd.phone;
      }
    },
  },
};
</script>

<style lang="scss">
// ============= Element-UI Customization

.el-select .el-input__inner:focus {
  border-color: black;
}

.el-icon-arrow-up:before {
  content: url("../../assets/imgs/arrow.svg");
}
.el-select .el-input .el-select__caret {
  transform: rotateZ(90deg);
}
.el-select .el-input .el-select__caret.is-reverse {
  transform: rotateZ(90deg);
}
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border-color: $black;
}
.el-input__icon {
  width: auto;
  margin-right: 20px;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 0;
}
.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  display: none;
}
.el-select-dropdown__item.selected {
  color: $black;
}

.el-select-dropdown {
  border: 2px solid $black;
  border-top: none;
  border-radius: 0;
  will-change: transform;
}
.el-radio,
.el-radio span {
  color: rgba(96, 98, 102, 0.8);
  // font-family: "Hm-Pangram-bold";
  font-family: "Firago-Book";
}
.el-input__prefix {
  left: initial;
  right: 0;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.el-radio__inner {
  width: 20px;
  height: 20px;
  transition: 0.4s;
  &:hover {
    border-color: #ffcb05;
  }
}
.el-radio__input.is-checked + .el-radio__label {
  color: #4d4d4f;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #ffcb05;
  border-width: 2px;
  background: white;

  &:after {
    background-color: #ffcb05;
    width: 10px;
    height: 10px;
  }
}

.el-input--prefix .el-input__inner {
  padding-left: 20px;
  padding-right: 20px;
}

.el-input--suffix .el-input__inner {
  padding-left: 20px;
  padding-right: 20px;
}

.el-icon-date {
  &:before {
    content: "";
  }
}

.el-checkbox__label {
  // font-family: "Hm-Pangram-bold";
  font-family: "Firago-Book";
}

.el-checkbox {
  align-items: center;
  display: flex;
}

.el-date-table td.today span,
.el-date-table td.available:hover {
  color: black;
}
.el-date-table td.current:not(.disabled) span {
  background-color: #1a1a1a;
}

// =============
.register-form {
  background-color: #f7f7f7;
  &__button {
    background-color: #4d4d4f;
    width: fit-content;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.4s;
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
    @include hover {
      background-color: #1a1a1a;
    }
  }
  &__date-picker {
    position: relative;
    &--icons {
      position: absolute;
      right: 20px;
      top: 0;
      height: 60px;
      z-index: 10;
      align-items: center;
    }
    &--calendar,
    &--clear {
      position: absolute;
      top: 18px;
      right: 20px;
    }
    &--clear {
      top: 22px;
      cursor: pointer;
    }
  }
  &__verification-wrapper {
    .f-13:nth-child(2) {
      color: rgba(77, 77, 79, 0.6);
    }
  }
  &__check-terms {
    a {
      color: #4d4d4f;
      text-decoration: underline;
    }
  }
  &__sms-code-wrapper {
    position: relative;
    span {
      position: absolute;
      top: 20px;
      right: 20px;
      transition: 0.4s;
      color: #1a1a1a !important;
      @include hover {
        color: $red;
      }
      @media (max-width: 413px) {
        font-size: 10px;
        right: 10px;
        top: 23px;
      }
    }
  }

  input {
    height: 60px;
    border-radius: 0px;
    border: 2px solid #c9c9ca;
    font-size: 13px;
    line-height: 24px;
    // font-family: "Hm-Pangram-bold";
    font-family: "Firago-Book";
    padding: 20px;
    color: #4d4d4f;
    transition: 0.4s;

    border-color: #c9c9ca;
    &::placeholder {
      color: rgba(96, 98, 102, 0.8);
    }
    &:focus {
      border-color: black;
    }
  }

  &__phone-wrapper {
    border: 2px solid #c9c9ca;
    transition: 0.4s;
    width: 645px;
    .el-icon-arrow-up:before {
      width: 6px;
      height: 8px;
      content: url("../../assets/imgs/arrow-small.svg");
    }
    &.custom_focus {
      border-color: black;
      border: 2px solid black;
    }
    input {
      height: 56px;
      &:nth-child(2) {
        border-left: transparent;
        border: none;
      }
    }

    .el-select {
      position: relative;
      width: 87px;
      &:after {
        position: absolute;
        content: "";
        top: 20px;
        right: 0;
        height: 20px;
        background-color: #c9c9ca;
        width: 1px;
      }
      input {
        border-right: transparent;
        border: none;
        // border-left: #c9c9ca !important;
      }
    }
  }
  &__inner {
    width: 962px;
    margin: 0 auto;
  }
  &__fields {
    background-color: white;
  }

  @media (max-width: 1023px) {
    &__inner {
      width: 100%;
      padding-left: 45px;
      padding-right: 45px;
    }
    &__fields {
      padding-left: 21px;
      padding-right: 21px;
    }
    &__phone-wrapper {
      input {
        width: 100%;
      }
      .el-select {
        width: 150px;
      }
    }
    &__button {
      padding-left: 20px;
      padding-right: 20px;
      margin-left: 10px;
    }
  }
  @media (max-width: 767px) {
    padding-bottom: 55px;

    .mb-30 {
      margin-bottom: 20px;
    }
    &__inner {
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      .f-34 {
        font-size: 21px;
      }
      .f-16 {
        font-size: 14px;
      }
    }
    &__fields {
      padding-left: 21px;
      padding-right: 21px;
      padding-top: 34px;
      padding-bottom: 34px;
    }
    .flex.mb-13 {
      flex-direction: column;
    }
    &__phone-wrapper {
      width: 100%;
      input {
        width: 100%;
      }
      .el-select {
        width: 150px;
        input {
          width: 100px !important;
        }
      }
    }
    &__button {
      margin-left: 0;
      margin-top: 21px;
    }
  }
  @media (max-width: 413px) {
    &__sex-boxes {
      .flex {
        flex-direction: column;
        label:first-child {
          margin-bottom: 21px;
        }
      }
    }
  }
}
</style>
